import styled from "styled-components";
import { Link } from 'react-router-dom';
import { Button, Table } from "semantic-ui-react";

export const Container = styled.div`
  width: 100%;
  
  background: #FFFFFF;
`;

export const Title =  styled.h1`
  width: 100%;
  max-width: 1100px;
  
  margin:0px auto 15px auto;
  padding-bottom: 5px;

  color:#000000;

  border-bottom: 1px solid rgba(0, 0, 0, .15);

  font-size:28px;
  font-family:sans-serif;
  font-weight:600;
`;

export const ContainerInputSearch = styled.div`
  width: 100%;
  height: 50px;
  
  & i{
    height: 75% !important;
  }
`;

export const SearchButton = styled.div`
  width: 100%;
  height: 50px;
  display: flex;

  margin-left: auto;
  margin-right: auto;
`;

export const Input = styled.input`
  width:100%;
  height:35px;
  margin:0;
  padding: .67857143em 1em;
  outline:0;
  background:#FFFFFF;
  color:rgba(0,0,0,.87);
  font-size:13px;
  font-family:sans-serif;
  font-weight:400;
  border:1px solid rgba(34,36,38,.15);
  border-radius:4px;
  -webkit-appearance:none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color .1s ease,border-color .1s ease;
`;

export const Info = styled.div`
  width: 100%;
  max-width: 1100px;
  height:100px;
  margin-bottom:20px;
  background: #f8f8f9;
  border: 1px solid rgba(0,0,0,.15);
  border-radius: 5px;
  display: flex;
  align-items: center;

  div {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 36px;
      margin-top: 15px;
    }
  }

  div + div {
    width: auto;
    
    p{
      line-height: 24px;
    }
  }
`

export const FildInline = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;

  label{
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 700;
  }

  div{
    width: 30% !important;
    height: 30px !important;
    margin-left: 10px;
  }

  label:nth-child(2){
    margin-left: 10px;
  }
`

export const CreateButton = styled(Link)`
  width: 100px;
  height: 35px;

  margin-left: 3px;

  color: #000000;
  background: #e0e1e2;

  border-radius: 5px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: 600;

  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover{
    background: #cacbcd;
    font-weight: 700;
    color: #000000;
  }
`;

export const SemanticTable = styled(Table)`
  th {
    font-size: 14 !important;
    font-family: sans-serif !important;
  }

  tr {
    font-size: 14;
    font-family: sans-serif;
    text-align: left;
    :hover {
      background: rgba(34, 36, 38, 0.1);
    }
  }
`;

export const StatusToggle = styled.a`
    padding: 8px;
    background: #f2711c;
    color: #fff;
    font-family: sans-serif;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    cursor: pointer;

  &:hover{
    background: #f26202 !important;
    color: #ffffff !important;
  }
`;

export const LinkRedirect = styled(Link)`
  color: rgba(0,0,255,.8);
  cursor: pointer;

  &:hover{
    text-decoration: none;
    color: darkblue;
  }
`;

export const SemanticButton = styled(Button)`
  background: none !important;
  border: none;
  i {
    color: #9999;
    :hover {
      color: ${props => (props.info === "delete" ? "red" : "#2185d0")};
    }
  }

  transition: all 0.6s;
`;





